import Axios from 'axios';
import { getConfiguration } from '../shared/utils/configuration';
import {
  PricingClient,
  ProductPriceCalculationRequest,
  ProductSizePriceDto,
} from '@kotipizzagroup/kotipizza-pricing-api-client';
import { getRequestHeaders } from './utils';

let client: PricingClient | null = null;

const getApiClient = (): PricingClient => {
  if (client) return client;

  const baseUrl = getConfiguration<string>('pricingService.root', '');

  // pricing-api-client 2.0 stopped JSON.parse-ing response bodies and expects axios to have
  // parsed them, so this instance must keep axios's default parsing (no `transformResponse: []`).
  const instance = Axios.create({
    timeout: 120000,
  });

  instance.interceptors.request.use(async (config) => {
    const headers = await getRequestHeaders();
    config.headers = headers;
    return config;
  });

  client = new PricingClient(baseUrl, instance);
  return client;
};

export const calculateProductDefaultPrices = async (
  payload: ProductPriceCalculationRequest
): Promise<ProductSizePriceDto[]> => {
  const client = getApiClient();
  return client.calculateProductDefaultPrices(payload);
};
